import {i18n} from '@netx/core/i18n';

export const AuthTitle = {
	FORGOT_PASSWORD: i18n.t('i18n.forgotPassword'),
	REGISTER_ACCOUNT: i18n.t('i18n.registerAccount'),
	UPDATE_PASSWORD: i18n.t('i18n.resetYourPassword'),
};

export const AuthActionLabel = {
	CREATE_ACCOUNT: i18n.t('i18n.createAccount'),
	CREATE_NEW_ACCOUNT: i18n.t('i18n.createNewAccount'),
	FORGOT_PASSWORD: i18n.t('i18n.forgotPassword'),
	RETURN_TO_LOGIN: i18n.t('i18n.returnToLogin'),
	SEND_PASSWORD_RESET_EMAIL: i18n.t('i18n.sendResetEmail'),
	SIGN_IN: i18n.t('i18n.signIn'),
	UPDATE_PASSWORD: i18n.t('i18n.changePassword'),
};

export const AuthMessage = {
	AWAITING_APPROVAL: i18n.t('i18n.receivedMessage'),
	INVALID_LOGIN: i18n.t('i18n.loginIncorrect'),
	RESET_PASSWORD_REQUEST: i18n.t('i18n.passwordStep1Instructions'),
	PASSWORD_RESET_SENT: i18n.t('i18n.passwordResetEmailSent'),
	PASSWORD_RESET_REQUEST_FAILED: i18n.t('i18n.couldNotSendPasswordResetEmail'),
	PASSWORD_UPDATE_INSTRUCTIONS: i18n.t('i18n.passwordChangeInstructions'),
	// TODO: this is a terrible key for this
	PASSWORD_UPDATE_WARNING: (minPasswordLength: number) =>
		i18n.t('i18n.passwordLength', {count: minPasswordLength}),
	PASSWORD_UPDATE_FAILED: i18n.t('i18n.couldNotSendResetPassword'),
	PASSOWRD_UPDATED_SIGNIN_REQUIRED: i18n.t('i18n.passwordChangedLogIn'),
	REGISTRATION_SUCCESS: i18n.t('i18n.registrationSuccessful'),
	SIGNING_IN: i18n.t('i18n.signingIn'),
	SIGNED_IN: i18n.t('i18n.signedInRedirecting'),
	SIGNED_OUT_INACTIVITY: i18n.t('i18n.youWereLoggedOut'),
};

export const AuthFieldLabel = {
	email: i18n.t('i18n.email'),
	login: i18n.t('i18n.username'),
	name1: i18n.t('i18n.firstName'),
	name3: i18n.t('i18n.lastName'),
	password1: i18n.t('i18n.password'),
	password2: i18n.t('i18n.confirmPassword'),
};
